import React, { useState } from "react";
import Button from "Components/UI/Button/Button";
import { Input } from "antd";
import { FilterItemProps } from "Components/PageTable/PageTable";
import styled from "./PickUp.module.scss";

const PickUp: React.FC<FilterItemProps> = ({ openStateToggler: toggleOpenState }) => {
  const [mode, setMode] = useState("inline");
  const changeMode = () => {
    setMode(mode ? "vertical" : "inline");
  };
  return (
    <div className={styled.container}>
      <div className={styled.container__backg}>
        <h4 className={styled.container__backg__text}>Pickup point</h4>
        <div className={styled.container__backg__registr}>
          <Input
            placeholder="Start input..."
            className={styled.container__backg__registr_input}
          />
          <h4 className={styled.container__backg__registr_text}>
            Delivery point
          </h4>
          <Input
            placeholder="Start input..."
            className={styled.container__backg__registr_input}
          />
        </div>

        <Button
          className={styled.container__backg_btn}
          onClick={toggleOpenState}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default PickUp;
